"use client";

import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import LOCAL_STORAGE from "@/constants/local-storage";
import ROUTE_URLS from "@/constants/route-urls";
import { Language, LanguageContextProps, LanguageProviderProps } from "@/types/language.types";

const DEFAULT_LANGUAGE: Language = "PT-BR";

export const LanguageContext = createContext<LanguageContextProps>({} as LanguageContextProps);

export const LanguageProvider = ({ children }: LanguageProviderProps) => {
  const [lang, setLang] = useState<Language>(DEFAULT_LANGUAGE);

  const params = useParams();
  const location = useLocation();
  const pathname = location.pathname;
  const router = useNavigate();

  useEffect(() => {
    if (!localStorage) return;

    const localStorageLang = (localStorage.getItem(LOCAL_STORAGE.lang) as Language) || null;
    const langParam = params?.lang;
    const languageToSet = localStorageLang || (langParam as Language) || DEFAULT_LANGUAGE;

    if (lang !== languageToSet) {
      setLang(languageToSet);
    }

    if (localStorageLang !== languageToSet) {
      localStorage.setItem(LOCAL_STORAGE.lang, languageToSet);
    }

    // Redirecionamento da rota raiz removido - agora é handled pela página Home

    const currentLangInPath = params?.lang || DEFAULT_LANGUAGE;
    const newPathname = pathname?.replace(`/${currentLangInPath}`, `/${languageToSet}`);

    if (newPathname !== pathname) {
      router(newPathname, { replace: true });
    }
  }, [lang, params?.lang, pathname, router]);

  return <LanguageContext.Provider value={{ lang }}>{children}</LanguageContext.Provider>;
};

const useLanguage = () => useContext(LanguageContext);

export default useLanguage;
